// TODO: Add staging/prod environments here. Can use environment variables
export function getBackendUrl(uri) {
  // e.g. if(process.env.NODE_ENV === "dev") { ... }
  if (uri[0] !== "/") {
    uri = `/${uri}`;
  }

  const environment =
    process.env.NEXT_PUBLIC_FIREBASE_ENVIRONMENT || "development";

  // local: http://localhost:8080
  // https://tom-orchid-staging.web.app
  // https://tom-staging-orchid.uc.r.appspot.com
  // https://orchid-434cb.web.app
  // https://orchid-434cb.appspot.com
  const firebaseUrl =
    environment === "development"
      ? "https://tom-staging-orchid.uc.r.appspot.com"
      : "https://orchid-434cb.appspot.com";

  return `${firebaseUrl}${uri}`;
}

export function getStripePublicKey() {
  const environment =
    process.env.NEXT_PUBLIC_FIREBASE_ENVIRONMENT || "development";

  return environment === "development"
    ? "pk_test_mXagzTaCtI2LlavJG9qFNSvs002vKpkyfW"
    : "pk_live_G6ahwoiS8B0eiL6zdXVm6RHX00kZ1mIeOp";
}
